var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import getOpenServiceEntries from '../../requests/service/getOpenServiceEntries';
/**
 *
 */
var GetOpenServiceEntriesCommand = /** @class */ (function (_super) {
    __extends(GetOpenServiceEntriesCommand, _super);
    function GetOpenServiceEntriesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisation OrganisationModel
     * @param serviceEntriesCollection ServiceEntriesCollection
     * @return {*}
     */
    GetOpenServiceEntriesCommand.prototype.execute = function (organisation, serviceEntriesCollection) {
        this.serviceEntriesCollection = serviceEntriesCollection;
        var promise = getOpenServiceEntries(organisation);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    GetOpenServiceEntriesCommand.prototype.then = function (response) {
        this.serviceEntriesCollection.reset(false);
        this.serviceEntriesCollection.addAll(response);
    };
    return GetOpenServiceEntriesCommand;
}(Command));
export default GetOpenServiceEntriesCommand;
